import { render, staticRenderFns } from "./MaterialLabelPrint.vue?vue&type=template&id=1f113b2c&scoped=true"
import script from "./MaterialLabelPrint.vue?vue&type=script&lang=js"
export * from "./MaterialLabelPrint.vue?vue&type=script&lang=js"
import style0 from "./MaterialLabelPrint.vue?vue&type=style&index=0&id=1f113b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f113b2c",
  null
  
)

export default component.exports